import { getMultipleValuesInSingleSelectionError } from '@angular/cdk/collections';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ColumnSettings } from '../../common/models';

@Component({
  selector: 'combo-viewer',
  templateUrl: './combo-viewer.component.html',
  styleUrls: ['./combo-viewer.component.scss']
})
export class SabisGrid2ComboViewerComponent implements OnChanges {
  @Input('record') record: any;
  @Input('column') column!: ColumnSettings;

  public options: any[] = [];
  public optionLabelName: string = '';
  public selectedOption: any = null;

  public displayText: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['record'] || changes['column']) {
      if (!this.column.comboSettings) {
        throw 'this.column.comboSettings cannot be null';
      }

      // consider data as not loaded yet
      if (!this.column.comboSettings.data) {
        return;
      }

      // option value
      let optionValue = this.record[this.column.field];
      if (!optionValue) {
        return;
      }

      if (typeof this.column.comboSettings.data === typeof []) {
        let values = this.column.comboSettings.data as any[];
        if (values.length === 0) {
          return;
        }
      }

      this.optionLabelName = this.column.comboSettings.textField;
      this.options = this.column.comboSettings.data as any[];
      this.selectedOption = this.options.find(o => o[this.column.comboSettings!.valueField] === optionValue);

      if(this.selectedOption) {
        this.displayText = this.selectedOption[this.column.comboSettings!.textField];
      }
    }
  }

  //public onModelChange(change: any): void {
  //  this.record![this.column.field] = change[this.column.comboSettings!.valueField];
  //}
}

